import * as Icons from "lucide-react";
import { cn } from "@/lib/utils";
import { CTA_SAFETY_BADGES } from "@/data/content";

// Lightweight trust/safety badges shown directly beneath major CTAs.
// Copy is compliance-safe: no \"money-back pass guarantee\", no \"official/approved\".
export const CtaSafetyBadges = ({ tone = "light", className }) => (
  <ul
    className={cn("flex flex-wrap items-center justify-center gap-x-4 gap-y-2", className)}
    aria-label="Purchase safety and product info"
  >
    {CTA_SAFETY_BADGES.map((b) => {
      const Icon = Icons[b.icon] || Icons.Check;
      return (
        <li
          key={b.label}
          className={cn(
            "inline-flex items-center gap-1.5 text-xs font-medium",
            tone === "navy"
              ? "text-[color:rgba(255,255,255,0.78)]"
              : "text-[color:rgba(11,18,32,0.7)]"
          )}
        >
          <Icon
            className={cn(
              "h-3.5 w-3.5",
              tone === "navy" ? "text-[#E7BE4A]" : "text-[var(--ibp-gold-600,#b88a12)]"
            )}
            aria-hidden="true"
          />
          {b.label}
        </li>
      );
    })}
  </ul>
);

export default CtaSafetyBadges;
